import { sizeOf } from './nodeSize';

export function buildGraph(tasks, positionRecord, boxes) {
  const nodePositions = {};
  const nodeDimensions = {};
  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;
  tasks.forEach((task) => {
    const pos = positionRecord[task.id];
    if (!task?.id || !pos) return;
    const { width, height } = sizeOf(task, boxes);
    nodePositions[task.id] = pos;
    nodeDimensions[task.id] = { width, height };
    minX = Math.min(minX, pos.x);
    minY = Math.min(minY, pos.y);
    maxX = Math.max(maxX, pos.x + width);
    maxY = Math.max(maxY, pos.y + height);
  });
  const pad = 80;
  const contentBounds = Number.isFinite(minX)
    ? {
      minX: minX - pad,
      minY: minY - pad,
      maxX: maxX + pad,
      maxY: maxY + pad,
      width: maxX - minX + pad * 2,
      height: maxY - minY + pad * 2,
    }
    : { minX: 0, minY: 0, maxX: 400, maxY: 300, width: 400, height: 300 };
  return { nodePositions, nodeDimensions, contentBounds };
}

/** Which missions a card is tied to. A rewire has to change this, not only the count. */
export function connectionSignature(task) {
  const ids = [];
  const conditions = task?.unlockConditions;
  if (conditions?.version === 2 && Array.isArray(conditions.blocks)) {
    conditions.blocks.forEach((block) => {
      (block?.conditions || []).forEach((condition) => {
        if (condition?.taskId) ids.push(`${condition.taskId}:${condition.branch || ''}`);
      });
    });
  } else if (Array.isArray(task?.dependsOn)) {
    task.dependsOn.forEach((dep) => {
      const id = typeof dep === 'string' ? dep : dep?.taskId;
      if (id) ids.push(`${id}:${typeof dep === 'object' ? (dep.branch || '') : ''}`);
    });
  }
  ids.sort();
  return ids.join(',');
}

export function buildLayoutKey(tasks, boxes) {
  let key = '';
  tasks.forEach((task) => {
    if (!task?.id) return;
    const size = sizeOf(task, boxes);
    key += `${task.id}:${Math.round(size.width)}x${Math.round(size.height)}:${task.x}:${task.y}:${task.nodeType || ''}:${connectionSignature(task)};`;
  });
  return key;
}
